import { KeycloakService } from 'keycloak-angular';

export function initializeKeycloak(keycloak: KeycloakService) {
  return async (): Promise<void> => {
    const authenticated = await keycloak.init({
      config: {
        url: 'https://www.b2blms.com:8443',
        realm: 'lonalyB2B',
        clientId: 'B2BLoanly',
      },
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false,
        enableLogging: true,
        flow: 'standard',
        pkceMethod: 'S256',
      },
      enableBearerInterceptor: false,
    });

    if (authenticated) {
      await saveAuthToStorage(keycloak);
      keycloak;
    }
  };
}

/**
 * Save token + role to localStorage
 */
export async function saveAuthToStorage(keycloak: KeycloakService): Promise<void> {
  try {
    const token = await keycloak.getToken();
    const tokenParsed: any = keycloak.getKeycloakInstance().tokenParsed || {};

    const realmRoles: string[] = tokenParsed.realm_access?.roles || [];
    const clientRoles: string[] = tokenParsed.resource_access?.['B2BLoanly']?.roles || [];
    const role = realmRoles[0] || clientRoles[0] || '';

    localStorage.setItem('auth_token', token);
    localStorage.setItem('role', role);
  } catch (err) {
    console.error('Failed to save auth details to localStorage', err);
  }
}
